import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
} from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Alert from "react-bootstrap/Alert";

import axios from "axios";
import authHeader from "../../../services/auth-header";

import ContentLoader from "react-content-loader";

import TotalFinishedTasksChart from "./charts/TotalFinishedTasksChart";
import TopicProgressChart from "./charts/TopicProgressChart";

import $ from "jquery";

import { REST_API } from "./../../../services/constants";
import { Link } from "react-router-dom";
import tab from "bootstrap/js/src/tab";

const AdminDashboardOverview = forwardRef((props, ref) => {
  const [tableData, setTableData] = useState(null);
  const [serverDeniedAccess, setServerDeniedAccess] = useState(false);

  const refreshTableData = async () => {
    axios({
      method: "GET",
      url: REST_API + "/api/secure/analytics/progress_overview/",
      headers: await authHeader(),
    })
      .then((response) => {
        if (response.status === 200) {
          setServerDeniedAccess(false);
          setTableData(response.data);
        } else {
          setServerDeniedAccess(true);
        }
      })
      .catch((err) => {
        setServerDeniedAccess(false);
      });
  };

  const rotateTableHeaders = () => {
    $(function () {
      var header_height = 0;
      $("table th.vertical-rotation span").each(function () {
        if ($(this).outerWidth() > header_height) {
          console.log(
            "Updading outher width " +
              $(this).outerWidth() +
              " and height " +
              $(this).outerHeight() +
              " for header element",
          );
          header_height = $(this).outerWidth();
        }
      });

      $("table th.vertical-rotation").height(header_height);
    });
  };

  useEffect(() => {
    refreshTableData();
  }, []);

  useEffect(() => {
    console.log("Received data update. Updating layout...");
    console.log("TableData:", tableData);
    rotateTableHeaders();
  }, [tableData]);

  useImperativeHandle(ref, () => ({
    rotateTableHeaders() {
      console.log(`Received rotate table update trigger from parent component`);
      rotateTableHeaders();
    },
  }));

  return (
    <>
      <br />
      {tableData === undefined || tableData == null ? (
        serverDeniedAccess ? (
          <Alert variant="warning">
            Du hast nicht die benötigten Berechtigungen. Bitte frage einen
            Administrator.
          </Alert>
        ) : (
          <BootstrapCardDataTable
            style={{ marginBottom: 40, maxWidth: 1000 }}
          />
        )
      ) : (
        <>
          <Table className="admin-overview-table" striped bordered hover>
            <thead>
              <tr className="topic-header">
                <th>Thema</th>
                {tableData.topics.map((topic, topicIndex) => {
                  return (
                    <th key={topicIndex} colSpan={topic.tasks.length}>
                      <Link to={"/training/topic/" + topic.id}>
                        {topic.title}
                      </Link>
                    </th>
                  );
                })}
              </tr>
              <tr className="task-header">
                <th>Aufgabe</th>
                {tableData.topics.map((topic, topicIndex) => {
                  var count = -1;
                  return topic.tasks.map((task, taskIndex) => {
                    //
                    count++;
                    return (
                      <th key={taskIndex} className="task-name-header">
                        <span>
                          <Link
                            to={"/training/topic/" + task.topicId + "/" + count}
                          >
                            {task.name}
                          </Link>
                        </span>
                      </th>
                    );
                  });
                })}
              </tr>
              {tableData.user_states.map((attendee, index) => {
                return (
                  <tr key={index}>
                    {attendee.user === undefined ||
                    attendee.user == null ||
                    attendee.states === undefined ||
                    attendee.states == null ? (
                      <>
                        <th>Unknown user</th>
                        <td colSpan={attendee.states.length ?? 1}>No data</td>
                      </>
                    ) : (
                      <>
                        <th>
                          <Link
                            to={"/admin-dashboard/accounts/" + attendee.user.id}
                          >
                            {attendee.user.firstName +
                              " " +
                              attendee.user.lastName}
                          </Link>
                        </th>
                        {attendee.states.map((item, index) => {
                          return item ? (
                            <td key={index} className="bg-success"></td>
                          ) : (
                            <td key={index}></td>
                          );
                        })}
                      </>
                    )}
                  </tr>
                );
              })}
            </thead>
          </Table>

          <Row className="mx-w-100 w-100 py-5">
            <Col sm={12} md={6} lg={6}>
              <TotalFinishedTasksChart data={tableData} />
            </Col>
            <Col sm={12} md={6} lg={6}>
              <TopicProgressChart data={tableData} />
            </Col>
          </Row>
        </>
      )}
    </>
  );
});

export default AdminDashboardOverview;

const BootstrapCardDataTable = (props) => {
  return (
    <ContentLoader
      viewBox="0 0 1200 400"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="27" y="139" rx="4" ry="4" width="20" height="20" />
      <rect x="67" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="188" y="141" rx="10" ry="10" width="169" height="19" />
      <rect x="402" y="140" rx="10" ry="10" width="85" height="19" />
      <rect x="523" y="141" rx="10" ry="10" width="169" height="19" />
      <rect x="731" y="139" rx="10" ry="10" width="85" height="19" />
      <rect x="852" y="138" rx="10" ry="10" width="85" height="19" />

      <rect x="26" y="196" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="197" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="198" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="197" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="198" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="196" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="195" rx="10" ry="10" width="85" height="19" />

      <rect x="26" y="258" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="259" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="260" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="259" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="260" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="258" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="257" rx="10" ry="10" width="85" height="19" />

      <rect x="26" y="316" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="317" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="318" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="317" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="318" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="316" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="315" rx="10" ry="10" width="85" height="19" />

      <rect x="26" y="379" rx="4" ry="4" width="20" height="20" />
      <rect x="66" y="380" rx="10" ry="10" width="85" height="19" />
      <rect x="187" y="381" rx="10" ry="10" width="169" height="19" />
      <rect x="401" y="380" rx="10" ry="10" width="85" height="19" />
      <rect x="522" y="381" rx="10" ry="10" width="169" height="19" />
      <rect x="730" y="379" rx="10" ry="10" width="85" height="19" />
      <rect x="851" y="378" rx="10" ry="10" width="85" height="19" />

      <rect x="978" y="138" rx="10" ry="10" width="169" height="19" />
      <rect x="977" y="195" rx="10" ry="10" width="169" height="19" />
      <rect x="977" y="257" rx="10" ry="10" width="169" height="19" />
      <rect x="977" y="315" rx="10" ry="10" width="169" height="19" />
      <rect x="977" y="378" rx="10" ry="10" width="169" height="19" />

      <circle cx="37" cy="97" r="11" />
      <rect x="26" y="23" rx="5" ry="5" width="153" height="30" />
      <circle cx="77" cy="96" r="11" />
    </ContentLoader>
  );
};
